var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{staticClass:"py-2",attrs:{"show":"","variant":_vm.variant}},[_c('p',{staticClass:"mx-2"},[_vm._v(" "+_vm._s(_vm.info.message)+" "),_c('b-link',{attrs:{"href":_vm.info.href}},[_vm._v(" "+_vm._s(_vm.info.hrefMessage)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }